import axios from "axios";
import { urlAPI } from "../../config/config";
import { showSnackbar } from "../../redux/actions";
import { IPayrollShuttleEntry } from "../../interface/payrollShuttle";

export const deletePayrollShuttle = async (
    year: number,
    month: number,
    token: string,
    setEntries: (entries: IPayrollShuttleEntry[]) => void,
    dispatch: Function,
    setError: Function
) => {
    try {
        const response = await axios.delete(
            `${urlAPI}/payroll-shuttle/${year}/${month}`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        setEntries(response.data.message);
        dispatch(showSnackbar("Navette de paie supprimée.", "success"));
    } catch (error: any) {
        console.error(error);
        setError("Impossible de supprimer la navette de paie.");
        dispatch(showSnackbar("Erreur lors de la suppression de la navette de paie.", "error"));
    }
};
